<template>
<div>
  <div class="label_date">
    <v-checkbox style="margin-top:0" v-model="check_date"/>
    <b>Elegir número de semana como fecha de reporte de monitoreo</b>
  </div>
  <v-layout v-if="check_date">
    <v-flex md11>
      <in-select :value.sync="week_n" :items="weeks" p_icon="edit"/>
    </v-flex>
    <v-flex md1>
      <fs1-tooltip :text="`El número de semana estará asociado al presente año (${current_year}). Adicionalente, estará vinculado al día lunes de la semana en cuestión.`"/>
    </v-flex>
  </v-layout>
  <in-calendar v-else :date.sync="date" :required="true"/>
</div>
</template>

<script>
import { weeksInYear } from '@/functions/general.js';
const aa = (date) =>{
  //find the year of the current date  
  const oneJan =  new Date(date.getFullYear(), 0, 1);   
  // calculating number of days in given year before a given date   
  const numberOfDays =  Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));   
  // adding 1 since to current date and returns value starting from 0   
  return Math.ceil(( date.getDay() + 1 + numberOfDays) / 7);     
};
export default {
  props:['check','value'],
  data() {
    return {
      check_date:false,
      date:null,
      week_n:null,
      current_year: new Date().getFullYear(),
    };
  },
  watch:{
    check() {this.check_date = this.check},
    check_date(){ this.$emit('update:check', this.check_date) },
    date(){ 
      this.$emit('update:value', this.date)
      const w_n = this.date? aa(typeof this.date == 'string'?new Date(this.date):this.date):null;
      if(this.date && this.week_n != w_n) this.week_n = w_n;
    },
    week_n(){
      this.$emit('update:value', this.getMondayFromWeekNum(this.week_n,this.current_year).toISOString())
      //console.log(this.selectedItem.report_datetime);
    },
    value(v){ this.set_date(v) }
  },
  computed:{
    weeks() {
      const ys = [];
      for (let i = weeksInYear(new Date().getFullYear()); i > 0; i--) ys.push(i);
      return ys;
    },
  },
  created(){
    this.check_date = this.check;
    this.set_date(this.value);
  },
  methods:{
    set_date(v){
      if(v != this.date) this.date = (v||null);
    },
    getMondayFromWeekNum (weekNum, year) {
      const day = new Date(Date.UTC(year, 0, ((weekNum) * 7),13));
      while (day.getDay() !== 1/* lunes */) {
        day.setDate(day.getDate() - 1);
      }
      return day;
    },
  }
};
</script>

<style scoped>
.label_date>*{
  display: inline-block;
}
</style>